import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'core/core.module';

import { DebatesService } from './mars1-debates/debates.service';
import { TutorizationQuestionService } from './mars1-questions/services/tutorization-question.service';
import { TutorizationGroupService } from './mars1-questions/services/tutorization-group.service';

import { Mars1DebateComponent } from './mars1-debates/mars1-debate/mars1-debate.component';
import { Mars1DebateOpinionRowComponent } from './mars1-debates/mars1-debate/mars1-debate-opinion-row/mars1-debate-opinion-row.component';
import { Mars1DebatesComponent } from './mars1-debates/mars1-debates.component';
import { Mars1DebateRowComponent } from './mars1-debates/mars1-debate-row/mars1-debate-row.component';
import { Mars1MessagesComponent } from './mars1-messages/mars1-messages.component';
import { GroupsTutorizationRoutingModule } from './groups-tutorization-routing.module';
import { Mars1QuestionCreateComponent } from './mars1-questions/mars1-question-create/mars1-question-create.component';
import { Mars1QuestionDetailComponent } from './mars1-questions/mars1-question-detail/mars1-question-detail.component';
import { Mars1QuestionEditorComponent } from './mars1-questions/mars1-question-editor/mars1-question-editor.component';
import { Mars1QuestionsComponent } from './mars1-questions/mars1-questions.component';
import { Mars1QuestionsListComponent } from './mars1-questions/mars1-questions-list/mars1-questions-list.component';
import { Mars1QuestionsListRowComponent } from './mars1-questions/mars1-questions-list/mars1-questions-list-row/mars1-questions-list-row.component';

@NgModule({
  imports: [CommonModule, CoreModule, GroupsTutorizationRoutingModule],
  declarations: [
    Mars1DebateComponent,
    Mars1DebateOpinionRowComponent,
    Mars1DebatesComponent,
    Mars1DebateRowComponent,
    Mars1MessagesComponent,
    Mars1QuestionEditorComponent,
    Mars1QuestionsComponent,
    Mars1QuestionsListRowComponent,
    Mars1QuestionDetailComponent,
    Mars1QuestionsListComponent,
    Mars1QuestionCreateComponent
  ],
  exports: [
    Mars1DebateComponent,
    Mars1DebatesComponent,
    Mars1MessagesComponent,
    Mars1QuestionsComponent,
    Mars1QuestionsListComponent
  ],
  providers: [DebatesService, TutorizationQuestionService, TutorizationGroupService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GroupsTutorizationModule {}
